import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Link, Typography, List, ListItem } from '@mui/material';
import { TimeSignalAttribute } from 'graphql/types';
import { AttributeType } from './NoteAttribute';

type NoteAttributeValueProps = {
  textClassName: string;
  attribute: TimeSignalAttribute;
  type: AttributeType;
  value: string;
};

type TextAttributeValueProps = {
  className: string;
  value: string;
};

const useStyles = makeStyles((theme) => ({
  ul: {
    padding: theme.spacing(0)
  },
  li: {
    color: theme.palette.text.primary,
    fontFamily: theme.typography.caption.fontFamily,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight,
    padding: theme.spacing(0),
    paddingBottom: theme.spacing(0.5)
  }
}));

const TextAttributeValue: React.FC<TextAttributeValueProps> = ({
  value,
  className
}: TextAttributeValueProps) => {
  return (
    <Typography variant={'caption'} className={className}>
      {value}
    </Typography>
  );
};

const NoteAttributeValue: React.FC<NoteAttributeValueProps> = ({
  attribute,
  type,
  value,
  textClassName
}: NoteAttributeValueProps) => {
  const classes = useStyles();
  if (type === AttributeType.TEXT)
    return <TextAttributeValue className={textClassName} value={value} />;
  if (type === AttributeType.LINK)
    return (
      <Link
        href={attribute.value.value}
        target="_blank"
        data-testid="note-individual-attribute-link"
      >
        <TextAttributeValue className={textClassName} value={value} />
      </Link>
    );
  if (type === AttributeType.LIST)
    return (
      <List className={classes.ul}>
        {attribute.value.value.map((item: string) => (
          <ListItem key={item} className={classes.li}>
            {item}
          </ListItem>
        ))}
      </List>
    );
  return <></>;
};

export default React.memo(NoteAttributeValue);
